import { useQuery } from '@tanstack/react-query'
import { menusApi } from '@/api/endpoints/menus'

/**
 * Query hook to get full menu contents for editing
 * @param menuId Menu ID
 */
export function useMenuContents(menuId: number) {
  return useQuery({
    queryKey: ['menus', menuId, 'contents'],
    queryFn: () =>
      menusApi.getContents(menuId, {
        includeInactive: true,
        includeDeleted: false,
        includePriceStatus: true,
      }),
    enabled: !!menuId,
  })
}
